import { Injectable, inject } from '@angular/core'
import { environment } from '@front-app-environments/environment'
import { NetworkingService } from '../../networking/services/networking.service'
import { Observable } from 'rxjs'
import { Croptype } from '@agroone/entities'

@Injectable({
  providedIn: 'root',
})
export class CroptypeNetworkService {
  private network = inject(NetworkingService)

  get(): Observable<Croptype[]> {
    return this.network.get(`${environment.apiUrl}${environment.croptypes}`) as Observable<Croptype[]>
  }
}
